import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { auth, resetPassword } from "../../utils/firebase-utils";
import { ForgottenPasswordContext } from "../../contexts/forgotten-password-context";
import { UnregisteredEmailContext } from "../../contexts/unregistered-email-context";

import FormInput from "../form-components/form-input";
import Button from "../form-components/button";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";

import "./forgotten-password-form.styles.css";

const defaultFormFields = {
  email: "",
};

const ForgottenPasswordForm = () => {
  const { setOpenForgottenPasswordModal } = useContext(
    ForgottenPasswordContext
  );
  const { setOpenUnregisteredEmailModal } = useContext(
    UnregisteredEmailContext
  );
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { email } = formFields;

  const navigate = useNavigate();

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const handleModelClose = () => {
    setOpenForgottenPasswordModal(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await resetPassword(auth, email);
      setOpenForgottenPasswordModal(false);
      resetFormFields();
      navigate("/");
    } catch (error) {
      setOpenUnregisteredEmailModal(true);
      setOpenForgottenPasswordModal(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <div className="password-modal">
      <div className="password-modal-content">
        <div className="password-modal-header">
          <Button
            className="password-modal-close-button"
            onClick={handleModelClose}
          >
            <FontAwesomeIcon
              icon={faRectangleXmark}
              style={{ color: "#363832" }}
              size="2xl"
            />
          </Button>
        </div>

        <h1 className="password-modal-heading">Forgotten your password?</h1>

        <div className="password-modal-body">
          <div className="password-modal-body-line">No problem!</div>
          <div>
            Enter your email below and we'll send you a link to reset your
            password...
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <FormInput
            label={null}
            inputType="signIn"
            type="email"
            required
            onChange={handleChange}
            name="email"
            value={email}
          />

          <div className="password-button-container">
            <Button type="submit" buttonType="lowlandsGreen">
              Send reset link
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgottenPasswordForm;
